module.exports = __webpack_public_path__ + "static/youtube_btn-252a4e2666f35df06192cd07aa33e446.svg";